<template>
    <div :style="{height: objstyle + 'px'}">
        <el-row style="text-align: center;">
            <el-col :span="20" :offset="2"><h3>参数设置</h3></el-col>
            <el-col :span="2" v-if="mysign!='14'">
                <!--v-permission="['BUSINESS-ASSIGN-PROJECT-SETTING-SENDZL']"-->
                <el-button v-permission="['BUSINESS-ASSIGN-PROJECT-SETTING-SENDZL']" type="primary" icon="" size="medium" @click="setSubmitAll" :disabled="disvisable">提交</el-button>
            </el-col>
        </el-row>
        <el-row><!--热暖系统-->
            <el-form v-if="detailItem.categoryId==='1'">
                <el-row>
                    <el-col :span="5" :offset="14">
                        <el-form-item label="恢复出厂设置" >
                            <el-select v-model="structJson.a35" placeholder="暂时不用" size="mini">
                                <el-option
                                        v-for="item in a35s"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="开关机状态" >
                            <el-select v-model="structJson.a36" placeholder="开机" size="mini">
                                <el-option
                                        v-for="item in a36s"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row >
                    <el-col :span="1">
                        <el-tag
                                :key="items[0].label"
                                :type="items[0].type"
                                size="medium"
                                effect="plain">
                            {{ items[0].label }}
                        </el-tag>
                    </el-col>
                    <el-col :span="23">
                        <el-col :span="9" :offset="2" v-for="(i) in [1,2,3,4,5,6]" :key="i">
                            <el-form-item :label="i+''" >
                                <el-col :span="1">
                                    <i class="el-icon-alarm-clock"></i>
                                </el-col>
                                <el-col :span="9">
                                    <el-time-picker editable clearable
                                                    format="HH:mm"
                                                    value-format="HH:mm"
                                                    v-model="structJson['a'+(5+(i-1)*3)+'_1']"
                                                    :picker-options="{
                                                // selectableRange: `00:00:00-24:00:00`,
                                                // maxTime: '23:59'
                                            }"
                                                    :placeholder="'时段'+i" @blur="checkTime($event,{name:'a'+(5+(i-1)*3)+'_1'})">
                                    </el-time-picker>
                                </el-col>
                                <el-col :span="9">
                                    <el-input
                                            placeholder="设定温度"
                                            suffix-icon="iconfont iconbaowen"
                                            v-model="structJson['a'+(7+(i-1)*3)]">
                                    </el-input>
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="" >
                        <el-col :span="23" :offset="3">
                            <el-checkbox-group
                                    v-model="structJson.a37" @change="update($event,'a37_1')">
                                <el-checkbox v-for="item in weekdays" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
                            </el-checkbox-group>
                        </el-col>
                    </el-form-item>
                </el-row>
                <el-row >
                    <el-col :span="1">
                        <el-tag
                                :key="items[1].label"
                                :type="items[1].type"
                                size="medium"
                                effect="plain">
                            {{ items[1].label }}
                        </el-tag>
                    </el-col>
                    <el-col :span="23">
                        <el-col :span="9" :offset="2" v-for="(i) in ['1','2']" :key="i">
                            <el-form-item :label="i" >
                                <el-col :span="1">
                                    <i class="el-icon-alarm-clock"></i>
                                </el-col>
                                <el-col :span="9">
                                    <el-time-picker editable clearable
                                                    format="HH:mm"
                                                    value-format="HH:mm"
                                                    v-model="structJson['a'+(23+(i-1)*3)+'_1']"
                                                    :picker-options="{
                                                // selectableRange: `00:00:00-23:59:59`,
                                                // maxTime: '24:00'
                                            }"
                                                    :placeholder="'时段'+i">
                                    </el-time-picker>
                                </el-col>
                                <el-col :span="9">
                                    <el-input
                                            placeholder="设定温度"
                                            suffix-icon="iconfont iconbaowen"
                                            v-model="structJson['a'+(25+(i-1)*3)]">
                                    </el-input>
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="" >
                        <el-col :span="23" :offset="3">
                            <el-checkbox-group
                                    v-model="structJson.a37_1" @change="update($event,'a37')">
                                <el-checkbox v-for="item in weekdays" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
                            </el-checkbox-group>
                        </el-col>
                    </el-form-item>
                </el-row>
            </el-form>
            <el-form label-width="150px">
                <el-row >
                    <el-col :span="1" v-if="detailItem.categoryId==='1'">
                        <el-tag
                                :key="items[2].label"
                                :type="items[2].type"
                                size="medium"
                                effect="plain">
                            {{ items[2].label }}
                        </el-tag>
                    </el-col>
                    <el-col :span="23">
                        <div v-for="(item,i) in paramStruct" :key="i" >
                            <el-col :span="9" :offset="2"  v-if="filterA.indexOf(item.name)===-1">
                                <el-form-item :label="item.name_cn" >
                                    <el-col :span="10">
                                        <el-tooltip class="item" effect="light" :content="rangeText(item)" placement="left-start" v-if="item.type==='A'">
                                            <el-switch
                                                    v-model="structJson[item.name]"
                                                    active-color="#13ce66"
                                                    inactive-color="#ff4949">
                                            </el-switch>
                                        </el-tooltip>
                                        <el-select v-model="structJson[item.name]" v-if="item.type==='B'" >
                                            <el-option v-for="o in item.options" :key="o.values" :label="o.name_cn" :value="o.values">
                                            </el-option>
                                        </el-select>
                                        <el-tooltip class="item" effect="light" :content="rangeText(item)" placement="left-start" v-if="item.type==='C'">
                                            <el-input type="Number"
                                                      v-model="structJson[item.name]" @blur="checkRange(item)">
                                            </el-input>
                                        </el-tooltip>
                                        <el-time-picker editable clearable v-if="item.type==='D'"
                                                        format="HH:mm"
                                                        value-format="HH:mm"
                                                        v-model="structJson[item.name]"
                                                        :picker-options="{
                                                    // selectableRange: `00:00:00-24:00:00`,
                                                    // maxTime: '24:00:00'
                                                }" @blur="checkTime($event,item)">
                                        </el-time-picker>
                                    </el-col>
                                    <el-col :span="4" :offset="1" v-if="mysign==='14'">
                                        <!--v-permission="['BUSINESS-ASSIGN-PROJECT-SETTING-SENDZL']"-->
                                        <el-button v-permission="['BUSINESS-ASSIGN-PROJECT-SETTING-SENDZL']" type="primary" icon="" size="medium" @click="setSubmitSingle(item)">提交</el-button>
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </el-row>
        <!--<el-row v-if="detailItem.categoryId==='2'">&lt;!&ndash;新风系统&ndash;&gt;
        </el-row>
        <el-row v-if="detailItem.categoryId==='3'">&lt;!&ndash;净水系统&ndash;&gt;
        </el-row>-->
    </div>
</template>

<script>
    //import { mapGetters } from 'vuex'
    import {getInstall} from '@/api/install'
    import {getParam,sendZL} from '@/api/setting'
    import {deviceInfo} from "@/api/device";
    export default {
        name: '',
        data(){
            return {
                objstyle: 0,
                detailItem:{},
                paramStruct:{},
                pstructs:'',
                mysign:'',
                items: [
                    { type: 'danger', label: '工作日' },
                    { type: 'success', label: '休息日' },
                    { type: '', label: '可调参数' },
                    // { type: 'info', label: '标签三' },
                    // { type: 'warning', label: '标签五' }
                ],
                activeLabel:'',
                a35s:[
                    { value: '0', label: '暂时不用' },
                    { value: '1', label: '立即恢复' }
                ],
                a36s:[
                    { value: '0', label: '开机' },
                    { value: '1', label: '关机' }
                ],
                //存放简化结构及值
                dataJson:{},
                //存放参数结构及值
                structJson:{},
                weekdays:[
                    {value:'0',label:'周一'},
                    {value:'1',label:'周二'},
                    {value:'2',label:'周三'},
                    {value:'3',label:'周四'},
                    {value:'4',label:'周五'},
                    {value:'5',label:'周六'},
                    {value:'6',label:'周日'}
                ],
                disvisable:true,
                deviceInfo:{}
            }
        },
        computed: {
            /*...mapGetters([
                'deviceInfo'
            ]),*/
            filterA:function () {
                if(this.detailItem.categoryId==='1'){
                    return ['a5_1', 'a7', 'a8_1', 'a10', 'a11_1', 'a13', 'a14_1', 'a16', 'a17_1', 'a19', 'a20_1', 'a22', 'a23_1', 'a25', 'a26_1', 'a28', 'a35', 'a36', 'a37']
                }else{
                    return []
                }
            }
        },
        watch:{
        },
        methods: {
            // websocket监听pid
            listen(){
                // console.log('deviceInfo=',this.deviceInfo)
                this.$websocket.listen(this.deviceInfo.id)
            },
            // 获取设备信息（需要categoryId）
            init() {
                getInstall(this.deviceInfo.id).then(response => {
                    if (response.code != 200) return this.$message.error(response.msg)
                    this.getStruct(response.data)
                    this.$websocket.regist(this.refresh,this.deviceInfo.id.toString(),31)
                    this.$websocket.regist(this.handler,this.deviceInfo.id.toString(),33)
                })
            },
            getHeight(){
                this.objstyle = window.innerHeight -60 -40
            },
            // 获取参数结构
            getStruct(deviceData){
                getParam(this.deviceInfo.id).then(response => {
                    if (response.code != 200) return this.$message.error(response.msg)
                    this.paramStruct = response.data.struct
                    this.pstructs = response.data.pstructs
                    this.mysign = response.data.mysign
                    for (let i = 0; i < this.paramStruct.length; i++) {
                        if(deviceData.categoryId==='1'&&this.paramStruct[i].name==='a37'){
                            // this.structJson[this.paramStruct[i].name]=[]
                            this.$set(this.structJson, 'a37', [])
                            this.$set(this.structJson, 'a37_1', [])
                        }else{
                            this.$set(this.structJson,this.paramStruct[i].name,'')
                        }
                    }
                    this.detailItem = deviceData
                    this.getParamData()
                })
            },
            // websocket数据返回处理
            refresh(data){
                //
                let result = JSON.parse(data['msg_body'])
                console.log('获取参数结果',result)
                if (!result.code) {
                    this.$message.error('参数获取失败！')
                    return
                }
                this.disvisable=false
                let params = result.data.split(',')
                for (let i = 0; i < params.length; i++) {
                    this.dataJson[`a${i + 1}`] = params[i]
                }
                for (let i = 0; i < this.paramStruct.length; i++) {
                    if(this.detailItem.categoryId==='1'&&this.paramStruct[i].name==='a37'){
                        let binstr=this.getBits(this.dataJson[this.paramStruct[i].name])
                        console.log('binstr',binstr)
                        for (let j = 0; j < 7; j++) {
                            if(this.getBit(binstr,j)){
                                this.structJson['a37'].push(j.toString())
                            }else{
                                this.structJson['a37_1'].push(j.toString())
                            }
                        }//先分解成二进制 0-6位=1的就是a37,=0的是a37_1
                    }else if(this.paramStruct[i].type==='A'||this.paramStruct[i].type==='B'||this.paramStruct[i].type==='C'){
                        // this.structJson[this.paramStruct[i].name] = this.dataJson[this.paramStruct[i].name]
                        this.$set(this.structJson,this.paramStruct[i].name,this.dataJson[this.paramStruct[i].name])
                    }else if(this.paramStruct[i].type==='D'){
                        let time = this.dataJson[this.paramStruct[i].hh].toString().padStart(2,'0')+":"+this.dataJson[this.paramStruct[i].mm].toString().padStart(2,'0')
                        this.$set(this.structJson,this.paramStruct[i].name,time)
                        // console.log(this.paramStruct[i].name,this.structJson[this.paramStruct[i].name])
                    }
                }
                console.log('dataJson,structJson',this.dataJson,this.structJson)
            },
            handler(data) {
                // let index = parent.pids.indexOf(data.imei);
                let result = JSON.parse(data['msg_body'])
                if (result.code) {
                    this.$message.success('参数设置成功')
                    this.getParamData()
                    /*if (result.data.indexOf("a") === 0) {
                        $('#' + result.data + '_' + index).css('background', '#84AE64').css('color', '#fff');
                    }*/
                } else if(result.data !== 'getData') {
                    this.$message.error('参数设置失败')
                    this.getParamData()
                    /*if (result.data.indexOf("a") === 0) {
                        $('#' + result.data + '_' + index).css('background', '#C7608D').css('color', '#fff');
                    }*/
                }
            },
            // 发送获取参数协议
            getParamData(){
                let data={
                    pid : this.detailItem.pid.toString(),
                    control_object : 'getParameter',
                    sendtype : 'B',
                    reparameter : '0',
                    control_state : '0'
                }
                this.sendOrder(data)
            },
            // 发送指令
            sendOrder(data){
                sendZL(data).then(response => {
                    if (response.code != 200) return this.$message.error(response.msg)
                    this.$message.success(response.msg)
                })
            },
            // 范围内容显示
            rangeText(item){
                if(item.type==='A'&&item.options){
                    let options=item.options
                    return options[1].name_cn + '|' + options[0].name_cn
                }else if(item.type==='B'){
                    return ''
                }else if(item.type==='C'&&item.range){
                    let ranges=item.range.split(',')
                    return '参数设置范围为:'+ranges[0]+'---'+ranges[1]
                }
                return ''
            },
            // 范围验证
            checkRange(item){
                if(item.range){
                    let ranges=item.range.split(',')
                    let max = Number(ranges[1])
                    let min = Number(ranges[0])
                    let val = this.structJson[item.name]
                    if(val > max) {
                        this.structJson[item.name]=max
                    } else if (val < min) {
                        this.structJson[item.name]=min
                    }
                }
            },
            // 工作日、休息日星期互斥
            update(val,id){
                let arr = []
                this.weekdays.filter((item)=> {
                    if(val.indexOf(item.value)===-1){
                        arr.push(item.value)
                    }
                })
                this.$set(this.structJson, id, arr)
            },
            // 时间输入24：00转为-- --
            checkTime(e,item){
                console.log('checkTime',e,this.structJson[item.name].toString())
                if(this.structJson[item.name]==='24:00'){
                    this.structJson[item.name]= '-- --'
                    console.log('执行了--',this.structJson[item.name])
                }
                console.log(this.structJson[item.name])
            },
            // 数字转二进制字符串
            getBits (data) {
                return (Array(16).join('0') + Number(data).toString(2)).slice(-16)
            },
            // 二进制字符串获取某一位是否为1
            getBit (source, address) {
                let res = source.substr(source.length - 1 - Number(address), 1)
                return res === '1'
            },
            setBit (data, address, status) {
                return status ? (1 << address) | data : ~(1 << address) & data
            },
            // 全部设置参数提交
            setSubmitAll(){
                // console.log('structJson',this.structJson)
                // console.log('dataJson',this.dataJson)
                for (let i = 0; i < this.paramStruct.length; i++) {
                    if(this.detailItem.categoryId==='1'&&this.paramStruct[i].name==='a37'){
                        let val=this.dataJson['a37']
                        for (let j = 0; j < this.structJson['a37'].length; j++) {
                            val=this.setBit(val,this.structJson['a37'][j],true)
                        }
                        for (let j = 0; j < this.structJson['a37_1'].length; j++) {
                            val=this.setBit(val,this.structJson['a37_1'][j],false)
                        }
                        this.dataJson['a37']=val
                    }else if(this.paramStruct[i].type==='A'||this.paramStruct[i].type==='B'||this.paramStruct[i].type==='C'){
                        this.dataJson[this.paramStruct[i].name]=this.structJson[this.paramStruct[i].name]
                    }else if(this.paramStruct[i].type==='D'){
                        let times = this.structJson[this.paramStruct[i].name].split(":")
                        this.dataJson[this.paramStruct[i].hh]=times[0]
                        this.dataJson[this.paramStruct[i].mm]=times[1]
                    }
                }
                let reparameter=''
                for(let key in this.dataJson ){
                    reparameter+='#'+this.dataJson[key]
                }
                let data={
                    pid : this.detailItem.pid.toString(),
                    control_object : 'setParameter',
                    sendtype : 'C',
                    reparameter : reparameter.substring(1),
                    control_state : '0',
                    control_type: 'all'
                }
                console.log('要设置的参数',this.dataJson)
                this.sendOrder(data)
            },
            /**
             * 单独设置参数提交
             */
            setSubmitSingle(item){
                let val=''
                if(this.detailItem.categoryId==='1'){
                    return
                }else if(item.type==='A'||item.type==='B'||item.type==='C'){
                    val=this.structJson[item.name]
                }else if(item.type==='D'){
                    let times = this.structJson[item.name].split(":")
                    val=times[0]+"#"+times[1]
                }
                let head = item.protocol_head
                let data={
                    pid : this.detailItem.pid.toString(),
                    control_object : item.name,
                    sendtype : 'G',
                    reparameter : val,
                    control_state : head
                }
                console.log('要单独设置的参数',this.dataJson)
                this.sendOrder(data)
            }
        },
        created(){
            this.getHeight()
            let pid=Number(this.$route.query.pid)
            deviceInfo({pid:pid}).then(response => {
                if(response.code!=200){
                    this.$message.error(response.msg)
                }else {
                    this.deviceInfo = response.data
                    window.addEventListener('resize', this.getHeight)
                    this.listen()
                    this.init()
                }
            })
        }
    }
</script>

<style scoped>

</style>
